import React, { Component } from 'react';
import { Card, Button, Table, Form, Dropdown } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import Loading from '../Loading';
import { GetMachine_lastStatus } from '../../components/Functions/GetMachine';

class MachinesList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            macchine: null,
            sortColumn: null,
            sortDirection: 'asc',
            searchTerm: '',
            visibleColumns: {
                UC: true,
                MOD: true,
                FM: true,
                CP: true,
                TY: true,
                ER: true,
                IDS: true,
                IDR: true,
                NOTA: true,
                TIMESTAMP: true,
            },
        };
    }

    async componentDidMount() {
        try {
            const data = await GetMachine_lastStatus();
            this.setState({ macchine: data.STATI });
        } catch (error) {
            console.error('Errore caricamento macchine:', error);
        }
    }

    handleSort = (column) => {
        const { sortColumn, sortDirection, macchine } = this.state;
        let direction = 'asc';

        if (sortColumn === column && sortDirection === 'asc') {
            direction = 'desc';
        }

        const sortedData = [...macchine].sort((a, b) => {
            let aValue = a[column];
            let bValue = b[column];

            if (['CP', 'ER'].includes(column)) {
                aValue = parseFloat(aValue);
                bValue = parseFloat(bValue);
                return direction === 'asc' ? aValue - bValue : bValue - aValue;
            }

            if (column === 'TIMESTAMP') {
                const aDate = new Date(aValue);
                const bDate = new Date(bValue);
                return direction === 'asc' ? aDate - bDate : bDate - aDate;
            }

            aValue = aValue ? aValue.toString().toLowerCase() : '';
            bValue = bValue ? bValue.toString().toLowerCase() : '';
            if (aValue < bValue) return direction === 'asc' ? -1 : 1;
            if (aValue > bValue) return direction === 'asc' ? 1 : -1;
            return 0;
        });

        this.setState({
            macchine: sortedData,
            sortColumn: column,
            sortDirection: direction,
        });
    };

    renderSortIcon = (column) => {
        const { sortColumn, sortDirection } = this.state;
        if (sortColumn !== column) return null;
        return sortDirection === 'asc' ? ' ▲' : ' ▼';
    };

    handleSearchChange = (e) => {
        this.setState({ searchTerm: e.target.value });
    };

    handleColumnToggle = (column) => {
        this.setState((prevState) => ({
            visibleColumns: {
                ...prevState.visibleColumns,
                [column]: !prevState.visibleColumns[column],
            },
        }));
    };

    exportToExcel = (data, fileName = 'macchine.xlsx') => {
        const ws = XLSX.utils.json_to_sheet(data);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Macchine');
        const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
        const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
        saveAs(blob, fileName);
    };

    getExportData = (macchine) => {
        const { visibleColumns } = this.state;
        return macchine.map(m => {
            const row = {};
            Object.keys(visibleColumns).forEach(col => {
                if (visibleColumns[col]) {
                    row[col] = m[col];
                }
            });
            return row;
        });
    };

    render() {
        const { macchine, searchTerm, visibleColumns } = this.state;

        if (!macchine) return <Loading />;

        const filteredMacchine = macchine.filter(m =>
            Object.values(m).some(val =>
                val && val.toString().toLowerCase().includes(searchTerm.toLowerCase())
            )
        );

        const columnLabels = {
            UC: 'Matricola',
            MOD: 'Modello',
            FM: 'Marchio',
            CP: 'Postazione',
            TY: 'Tipo',
            ER: 'Errore',
            IDS: 'Sede',
            IDR: 'Reparto',
            NOTA: 'Nota',
            TIMESTAMP: 'Ultimo Aggiornamento',
        };

        const macchineAttive = filteredMacchine.filter(m => m.CP !== null && m.CP !== "null");
        const macchineDismesse = filteredMacchine.filter(m => m.CP === null || m.CP === "null");

        return (
            <div>
                <Dropdown className="mb-3">
                    <Dropdown.Toggle variant="secondary" id="dropdown-columns">
                        Mostra / Nascondi Colonne
                    </Dropdown.Toggle>
                    <Dropdown.Menu style={{ padding: '10px' }}>
                        {Object.entries(visibleColumns).map(([key, visible]) => (
                            <Form.Check
                                key={key}
                                type="checkbox"
                                id={`toggle-${key}`}
                                label={columnLabels[key] || key}
                                checked={visible}
                                onChange={() => this.handleColumnToggle(key)}
                                style={{ marginBottom: '5px' }}
                            />
                        ))}
                    </Dropdown.Menu>
                </Dropdown>

                <Card className="cardModifiche">
                    <Card.Header style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <div className="titleCard">Macchine</div>
                            <Link to="/Machines/newMachine">
                                <Button className="confirmButton">Aggiungi Nuova Macchina</Button>
                            </Link>
                        </div>
                        <Form.Control
                            type="text"
                            placeholder="Cerca tra tutti i campi..."
                            value={this.state.searchTerm}
                            onChange={this.handleSearchChange}
                        />
                        <div style={{ display: 'flex', justifyContent: 'flex-start' }}>
                            <Button
                                variant="success"
                                className="mb-3"
                                onClick={() => this.exportToExcel(this.getExportData(macchineAttive), 'macchine_attive.xlsx')}
                            >
                                Esporta Macchine Attive
                            </Button>
                        </div>

                    </Card.Header>
                    <Card.Body>
                        <Table striped bordered hover responsive>
                            <thead>
                                <tr>
                                    {Object.entries(visibleColumns).map(([key, visible]) => (
                                        visible && (
                                            <th key={key} onClick={() => this.handleSort(key)} style={{ cursor: 'pointer' }}>
                                                {columnLabels[key]}{this.renderSortIcon(key)}
                                            </th>
                                        )
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {macchineAttive.map((macchina, index) => (
                                    <tr key={index}>
                                        {Object.entries(visibleColumns).map(([key, visible]) => (
                                            visible && (
                                                <td key={key}>
                                                    {key === 'UC' ? (
                                                        <Link to={`/Machines/${macchina.UC}`}>{macchina[key]}</Link>
                                                    ) : macchina[key] && macchina[key] !== "null" ? (
                                                        macchina[key]
                                                    ) : (
                                                        '—'
                                                    )}
                                                </td>
                                            )
                                        ))}
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    </Card.Body>
                </Card>

                {macchineDismesse.length > 0 && (
                    <div style={{ marginTop: '2rem' }}>
                        <h5><strong>Macchinari Dismessi</strong></h5>
                        <Button
                            variant="warning"
                            className="mb-3"
                            onClick={() => this.exportToExcel(this.getExportData(macchineDismesse), 'macchine_dismesse.xlsx')}
                        >
                            Esporta Dismessi
                        </Button>
                        <Table striped bordered hover responsive>
                            <thead>
                                <tr>
                                    {Object.entries(visibleColumns).map(([key, visible]) => (
                                        visible && (
                                            <th key={`dismessi-th-${key}`}>{columnLabels[key]}</th>
                                        )
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {macchineDismesse.map((macchina, index) => (
                                    <tr key={`dismesso-${index}`}>
                                        {Object.entries(visibleColumns).map(([key, visible]) => (
                                            visible && (
                                                <td key={`dismesso-${key}`}>
                                                    {key === 'UC' ? (
                                                        <Link to={`/Machines/${macchina.UC}`}>{macchina[key]}</Link>
                                                    ) : macchina[key] && macchina[key] !== "null" ? (
                                                        macchina[key]
                                                    ) : (
                                                        '—'
                                                    )}
                                                </td>
                                            )
                                        ))}
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    </div>
                )}
            </div>
        );
    }
}

export default MachinesList;
